export default {
	"waitingResponse": "Waiting for validation",
	"validated": "Validated",
	"editFiles": "Edit Files",
	"viewDoc": "View Document",
	"validate": "Validate",
  "RepSecNotRequired": "REPSE validated!",
  "requiresRepSec": "Requires REPSE validation!",
  "userRoleDisclaimer": "If you select the Provider role, you need to add a provider to the user",
  "enteruserRoleId": "Enter user role",
  "msgAfterUpdateStatus": "Status successfully updated",
  "updateStatusTitle": "Update Status",
  "updateStatusMessage": "Do you want to update the status of this record?",
  "updateStatus": "Update Status",
  "setRejected": "Reject",
  "setApproved": "Approve",
  "setPaid": "Paid",
  "confirm": "Confirm",
  "enterComment": "Provide a comment",
  "rejectRepseTitle": "Reject REPSE",
  "rejectRepseMessage": "Do you want to reject the documents from the Specialized Service Providers or Specialized Works Registry (REPSE) to disable the provider?",
  "msgAfterReject": "Successfully rejected",
  "msgAfterAccept": "Successfully accepted",
  "acceptRepseTitle": "Validate REPSE",
  "acceptRepseMessage": "Do you want to validate the documents from the Specialized Service Providers or Specialized Works Registry (REPSE) to approve the provider?",
  "validRepse": "Validate REPSE",
  "rejectRepse": "Reject REPSE",
  "UnderReview": "Under review",
  "Valid": "Verified",
  "file_path_one": "SAT declaration",
  "file_path_two": "ISR declaration",
  "file_path_three": "Summary of settlements before the IMSS",
  "selectYesOrNo": "Select yes or no",
  "checking": "Checking...",
  "no": "No",
  "yes": "Yes",
  "checkRepse": "Requires REPSE?",
  "Active": "Active",
  "Inactive": "Inactive",
  "Definitive": "Definitive",
  "Distorted": "Distorted",
  "Presumed": "Presumed",
  "FavorableSentences": "Favorable sentences",
  "Allinvoices": "All invoices",
  "Recievedinvoices": "Received invoices",
  "Pendinginvoices": "Pending invoices",
  "Rejectedinvoices": "Rejected invoices",
  "Approvedinvoices": "Approved invoices",
  "Paidinvoices": "Paid invoices",
  "invoices": "Invoices",
  "aboutUs": "About us",
  "accountDetail": "Account details",
  "action": "Action",
  "addNewEfo": "Add EFOS",
  "addNewMail": "Add invoice email",
  "addNewPermission": "Add permission",
  "addNewRepse": "Add REPSE",
  "addNewRole": "Add role",
  "addNewSupplier": "Add supplier",
  "addNewTabledisplaylabel": "Add new",
  "addNewUser": "Add user",
  "addNewInvoice": "Add invoice",
  "editInvoice": "Edit invoice",
  "invoiceDetails": "Invoice details",
  "User": "User",
  "Admin": "Admin",
  "Supplier": "Supplier",
  "administration": "Administration",
  "allRightsReserved": "All rights reserved",
  "alreadyExist": "Already exists!",
  "alreadyHaveAnAccount": "Already have an account?",
  "available": "Available",
  "back": "Back",
  "browse": "Browse",
  "capitalLetter": "Capital letter",
  "changeEmail": "Change email",
  "changePassword": "Change password",
  "charactersMinimum": "minimum characters",
  "checkingAvailability": "Checking availability...",
  "chooseFilesOrDropFilesHere": "Choose files or drop files here",
  "clickHereToLogin": "Click here to login",
  "close": "Close",
  "confirmNewPassword": "Confirm new password",
  "confirmPassword": "Confirm password",
  "congratulations": "Congratulations!",
  "contactSystemAdmin": "Contact the system administrator for more information",
  "contactUs": "Contact us",
  "continue": "Continue",
  "createdAt": "Created at",
  "createRecord": "Create record",
  "currentPassword": "Current password",
  "dataImportedSuccessfully": "Data imported successfully",
  "delete": "Delete",
  "deleteAccount": "Delete account",
  "deleteRecord": "Delete record",
  "deleteSelected": "Delete selected",
  "deleteThisRecord": "Delete this record",
  "dontHaveAnAccount": "Don't have an account?",
  "edit": "Edit",
  "editAccount": "Edit account",
  "editEfo": "Edit Efo",
  "editMail": "Edit invoice",
  "editMyAccount": "Edit my account",
  "editPermission": "Edit permission",
  "editRepse": "Edit Repse",
  "editRole": "Edit role",
  "editSupplier": "Edit supplier",
  "editTabledisplaylabel": "Edit",
	"editThisRecord": "Edit this record",
	"editUser": "Edit User",
	"efoDetails": "Efo Details",
	"efosMenu": "EFOS",
	"efos": "Simulated Operations Billing Companies (EFOS)",
	"email": "Email",
	"emailAddressChanged": "The email address was successfully changed",
	"emailAddressNotRegistered": "The email address is not registered",
	"emailAddressVerified": "The email address is already verified",
	"emailNotChanged": "Email not changed",
	"emailOrPhoneNumber": "Email or phone number",
	"emailVerificationCompleted": "Email verification completed.",
	"emailVerificationResent": "Email verification has been resent",
	"emailVerificationSent": "Email verification link sent",
	"enterCellphone": "Enter phone number",
	"enterFielddisplaylabel": "Enter {FieldDisplayLabel}",
	"enterFkEfosStatus": "Enter EFOS status",
	"enterMail": "Enter email",
	"enterName": "Enter name",
	"name": "Name",
	"enterOtp": "Enter OTP",
	"enterPassword": "Enter password",
	"enterPermission": "Enter permission",
	"enterRfc": "Enter RFC",
	"enterRoleName": "Enter role name",
	"enterSender": "Enter sender",
	"enterStatus": "Enter Status",
	"enterTheCode": "Enter the code",
	"errorDeletingRecord": "Error deleting the record, please ensure the record exists",
	"errorInsertingRecord": "Error inserting the record",
	"errorProcessingRequest": "Error processing the request!",
	"errorRegisteringUser": "Error registering user",
	"errorSendingEmail": "Error sending email. Please contact the system administrator for more information",
	"errorUploadingFile": "Error uploading the file",
	"export": "Export",
	"exportCsv": "Export CSV",
	"exportExcel": "Export Excel",
	"exportPageFields": "Export page fields",
	"exportWord": "Export Word",
	"fileFormatNotSupported": "File format not supported",
	"fkEfosStatus": "EFOS Status",
	"formIsInvalid": "The form is invalid",
	"helpAndFaq": "Help and FAQ",
	"hi": "Hi",
	"home": "Home",
	"id": "Id",
	"importData": "Data import",
	"invalidCaptchaCode": "Invalid Captcha code",
	"invalidEmailVerifyLink": "The email verification link is invalid",
	"invalidRequest": "Invalid request",
	"language": "Language",
	"limit": "Limit",
	"loading": "Loading...",
	"loadMore": "Load more...",
	"login": "Login",
	"loginCompleted": "Login completed",
	"logout": "Logout",
	"mail": "Mail",
	"mailDetails": "Mail details",
	"mails": "Mails",
	"myAccount": "My account",
	"newPassword": "New password",
	"noFileSelectedForUpload": "No file selected for upload",
	"noMoreContentToLoad": "No more content to load",
	"noRecordFound": "No record found",
	"noRecordInserted": "No record inserted",
	"noRecordUpdated": "No record updated",
	"notAvailable": "Not available",
	"number": "Number",
	"of": "of",
	"otpSentEmail": "OTP has been sent to your email",
	"otpSentSMS": "OTP has been sent to your phone number via SMS",
	"otpVerification": "OTP Verification",
	"page": "Page",
	"password": "Password",
	"passwordChangedMsg": "Your password has been reset",
	"passwordHint": "Hint: at least 6 characters",
	"passwordReset": "Password reset manager",
	"passwordResetKeyFailure": "Password reset key failure",
	"passwordResetLinkMsg": "A link will be sent to your email containing the information needed to reset your password",
	"passwordResetMsg": "A message has been sent to your email. Kindly follow the link to reset your password",
	"passwordResetStepsMsg": "Please try resetting your password by following these steps",
	"pdfFile": "PDF File",
	"permission": "Permission",
	"errorLoadingFile": "Error loading the file",
	"receiptDate": "Receipt date",
	"permissionDetails": "Permission details",
	"openFileInNewTab": "Open file in new tab",
	"fileNotSupported": "File not supported by the browser",
	"Fileviewer": "File viewer",
	"All": "All",
	"Recivied": "Received",
	"Pending": "Pending",
	"Rejected": "Rejected",
	"Approved": "Approved",
	"Paid": "Paid",
	"Recivieds": "Received",
	"Pendings": "Pending",
	"Rejecteds": "Rejected",
	"Approveds": "Approval",
  "Paids": "Paid",
	"permissionId": "Permission Id",
	"permissions": "Permissions",
	"phoneNumber": "Phone number",
	"photo": "Photo",
	"cellphone": "Cellphone",
	"pleaseAChooseFile": "Please choose a file",
	"pleaseCompleteTheForm": "Please complete the form",
	"pleaseEnterText": "Please enter the text",
	"print": "Print",
	"printPageSettings": "Print page settings",
	"printPdf": "Print | PDF",
	"privacyPolicy": "Privacy policy",
	"promptAccountBlocked": "Your account has been blocked",
	"promptAccountCreated": "Your account has been created",
	"promptAccountInReview": "Your account is under review",
	"promptAccountNotActive": "Your account is not active. Please contact the system administrator for more information.",
	"promptDeleteRecord": "Are you sure you want to delete this record?",
	"promptDeleteRecords": "Are you sure you want to delete these records?",
	"promptEmailNotRegistered": "The email address is not registered in the system",
	"promptForValidEmail": "Please provide the valid email address you used to register",
	"promptPasswordConfirmFail": "Your password confirmation does not match",
	"promptPasswordExpired": "Your password has expired. Reset your password to continue.",
	"promptPasswordResetFailed": "Your password reset was not completed",
	"provideNewPassword": "Provide a new password",
	"recordAddedSuccessfully": "Record added successfully",
	"recordDeletedSuccessfully": "Record deleted successfully",
	"records": "Records",
	"recordUpdatedSuccessfully": "Record updated successfully",
	"register": "Register",
	"rememberMe": "Remember me",
	"removePageLinks": "Remove page links",
	"repseMenu": "REPSE",
	"repse": "Register of Specialized Service Providers or Specialized Works (REPSE)",
	"repseDetails": "REPSE details",
	"resendEmail": "Resend email",
	"resetPassword": "Reset password",
	"rfc": "RFC",
	"roleDetails": "Role details",
	"roleId": "Role Id",
	"roleName": "Role name",
	"rolePermissions": "Role permissions",
	"roles": "Roles",
	"rolesDetail": "Roles details",
	"roleUsers": "User roles",
	"savePng": "Save PNG",
	"saving": "Saving record",
	"search": "Search",
	"selectAFileToImport": "Select a file to import",
	"selectAValue": "Select a value",
	"selectPaperSize": "Select paper size",
	"send": "Send",
	"sender": "Sender",
	"shouldContain": "Should contain",
	"showHeader": "Show Header",
	"sortBy": "Sort by",
	"status": "Status",
	"fk_status": "Status",
	"submit": "Submit",
	"supplierDetails": "Supplier details",
	"suppliers": "Suppliers",
	"supplier": "Supplier",
	"supportedFileTypes": "Supported file types",
	"symbol": "Symbol",
	"tabledisplaylabelDetails": "View",
	"termsAndConditions": "Terms and Conditions",
	"theDashboard": "Dashboard",
	"comment": "Comment",
	"unableToCompleteRequest": "Unable to complete the request.",
	"update": "Update",
	"updatedAt": "Updated at",
	"updateRecord": "Update record",
	"userDetails": "User details",
	"userLogin": "User login",
	"username": "Username",
	"usernameEmailPhoneNumber": "Username / Email / Phone number",
	"usernameOrEmail": "Username or email",
	"usernameOrPasswordNotCorrect": "Username or password is incorrect",
	"usernameOrPhoneNumber": "Username or phone number",
	"userRegistration": "User registration",
	"userRoleId": "User role",
	"users": "Users",
	"verify": "Verify",
	"verifyEmailLinkMsg": "Verify your email address by following the link in your inbox",
	"view": "View",
	"viewRecord": "View record",
	"welcome": "Welcome",
	"xmlFile": "XML file",
	"startsWith": "Starts with",
	"contains": "Contains",
	"notContains": "Does not contain",
	"endsWith": "Ends with",
	"equals": "Equals",
	"notEquals": "Not equals",
	"noFilter": "No filter",
	"lt": "Less than",
	"lte": "Less than or equal to",
	"gt": "Greater than",
	"gte": "Greater than or equal to",
	"dateIs": "Date is",
  "dateIsNot": "Date is not",
	"dateBefore": "Date before",
	"dateAfter": "Date after",
	"custom": "Custom",
	"clear": "Clear",
	"apply": "Apply",
	"matchAll": "Match all",
	"matchAny": "Match any",
	"addRule": "Add rule",
	"removeRule": "Remove rule",
	"accept": "Yes",
	"reject": "No",
	"choose": "Choose",
	"upload": "Upload",
	"cancel": "Cancel",
	"dayNames": [
		"Sunday",
		"Monday",
		"Tuesday",
		"Wednesday",
		"Thursday",
		"Friday",
		"Saturday"
	],
	"dayNamesShort": ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	"dayNamesMin": ["S", "M", "T", "W", "T", "F", "S"],
	"monthNames": [
		"January",
		"February",
		"March",
		"April",
		"May",
		"June",
		"July",
		"August",
		"September",
		"October",
		"November",
		"December"
	],
	"monthNamesShort": [
		"Jan",
		"Feb",
		"Mar",
		"Apr",
		"May",
		"Jun",
		"Jul",
		"Aug",
		"Sep",
		"Oct",
		"Nov",
		"Dec"
	],
	"today": "Today",
	"weekHeader": "Wk",
	"firstDayOfWeek": 1,
	"showMonthAfterYear": false,
	"dateFormat": "dd/mm/yy",
	"weak": "Weak",
	"medium": "Medium",
	"strong": "Strong",
	"passwordPrompt": "Enter a password",
	"emptyFilterMessage": "No options available",
	"emptyMessage": "No results found",
	"uploadedFiles": "Uploaded files",
	"uploadFailed": "Upload failed",
	"maxFileLimit": "File limit of ${limit} exceeded!",
	"aria": {
		"trueLabel": "True",
		"falseLabel": "False",
		"nullLabel": "Not selected",
		"star": "1 star",
		"stars": "{star} stars",
		"selectAll": "Select all",
		"unselectAll": "Unselect all",
		"close": "Close",
		"previous": "Previous",
		"next": "Next",
		"navigation": "Navigation",
		"scrollTop": "Scroll to top",
		"moveTop": "Move to top",
		"moveUp": "Move up",
		"moveDown": "Move down",
		"moveBottom": "Scroll to bottom",
		"moveToTarget": "Move to target",
		"moveToSource": "Move to source",
		"moveAllToTarget": "Move all to target",
		"moveAllToSource": "Move all to source",
		"pageLabel": "{page}",
		"firstPageLabel": "First page",
		"lastPageLabel": "Last page",
		"nextPageLabel": "Next page",
		"previousPageLabel": "Previous page",
		"rowsPerPageLabel": "Rows per page",
		"jumpToPageDropdownLabel": "Go to page dropdown",
		"jumpToPageInputLabel": "Go to page input",
		"selectRow": "Select row",
		"unselectRow": "Unselect row",
		"expandRow": "Expand row",
		"collapseRow": "Collapse row",
		"showFilterMenu": "Show filter menu",
		"hideFilterMenu": "Hide filter menu",
		"filterOperator": "Filter operator",
		"filterConstraint": "Filter constraint",
		"editRow": "Edit row",
		"saveEdit": "Save edit",
		"cancelEdit": "Cancel edit",
		"listView": "List view",
		"gridView": "Grid view",
		"slide": "Slide",
		"slideNumber": "{slideNumber}",
		"zoomImage": "Zoom image",
		"zoomIn": "Zoom in",
		"zoomOut": "Zoom out",
		"rotateRight": "Rotate right",
		"rotateLeft": "Rotate left"
	},
	"validations": {
		"required": "This field is required.",
		"undefined": "This field is required.",
		"email": "The value is not a valid email address",
		"minLength": "This field must have at least ${min} characters",
		"maxLength": "The maximum allowed length is ${max}",
		"minValue": "The minimum allowed value is ${min}",
		"maxValue": "The maximum allowed value is ${max}",
		"numeric": "The value must be numeric",
		"ipAddress": "The value is not a valid IP address",
		"sameAs": "The value must be the same as ${otherName}"
	},
};